import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.css'

const Container = ({ children, fullWidth }) => (
  <div
    className={classNames({
      'w-100 mw950 ph3 center': true,
      'mw-none': fullWidth
    })}
  >
    {children}
  </div>
)

Container.propTypes = {
  children: PropTypes.node
}

export default Container



// WEBPACK FOOTER //
// ./src/components/container/container.js